import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerPageComponent } from './pages/partner/partner.page';
import { PartnerInfoComponent } from './components/partner-info/partner-info.component';
import { ChildrenListComponent } from './components/children-list/children-list.component';
import { WaiverDialogComponent } from './components/waiver-dialog/waiver-dialog.component';
import { Routes, RouterModule } from '@angular/router';
import { MaterialModule } from '../../material.module';
import { FormsModule } from '@angular/forms';
import { PartnerOdooService } from './services/partner-odoo.service';
import { PartnerInMemoryService } from './services/partner-in-memory.service';
import { environment } from '../../../environments/environment';
import { PartnerService } from './services/partner.service';
import { GeneralModule } from '../general/general.module';
import { TranslateModule } from '@ngx-translate/core';
import { BookingStepService } from '../booking/services/booking-step.service';
import { PartnerStateService } from './services/partner-state.service';
import { PartnerProfileGuard } from './guards/partner-profile.guard';
import { ChildrenManagementComponent } from './components/children-management/children-management.component';
import { PartnerContactComponent } from './components/partner-contact/partner-contact.component';
import { PartnerPasswordComponent } from './components/partner-password/partner-password.component';
import { WaiverCheckboxComponent } from './components/waiver-checkbox/waiver-checkbox.component';
import { PartnerRegistrationComponent } from './components/partner-registration/partner-registration.component';
import { PartnerRegistrationFormComponent } from './components/partner-registration-form/partner-registration-form.component';
import { OrdersComponent } from './components/orders/orders.component';
import { NewChildComponent } from './components/new-child/new-child.component';
import { EditChildComponent } from './components/edit-child/edit-child.component';
import { AddChildButtonComponent } from './components/add-child-button/add-child-button.component';
import { OrderModule } from '../order/order.module';
import { EditChildGuard } from './guards/edit-child.guard';
import { PartnerEditComponent } from './components/partner-edit/partner-edit.component';
import { PartnerFormComponent } from './components/partner-form/partner-form.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { PartnerDeleteComponent } from './components/partner-delete/partner-delete.component';
import { BookingSlotChangeStateService } from './services/booking-slot-change-state-service.service';
import { CurrentPartnerContactComponent } from './components/current-partner-contact/current-partner-contact.component';
import { PartnerEditPopupComponent } from './components/partner-edit-popup/partner-edit-popup.component';
import { PartnerConfirmationTextComponent } from './components/partner-confirmation-text/partner-confirmation-text.component';

const partnerServiceClass = environment.production ? PartnerOdooService : PartnerInMemoryService;

const routes: Routes = [
  {
    path: 'partner',
    component: PartnerPageComponent,
    canActivate: [PartnerProfileGuard],
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            component: PartnerEditComponent,
            canActivate: [PartnerProfileGuard],
          },
          {
            path: 'children',
            component: ChildrenManagementComponent,
            canActivate: [PartnerProfileGuard],
            children: [
              {
                path: '',
                component: AddChildButtonComponent,
                canActivate: [PartnerProfileGuard],
              },
              {
                path: 'new',
                component: NewChildComponent,
                canActivate: [PartnerProfileGuard],
              },
              {
                path: 'edit',
                component: EditChildComponent,
                canActivate: [EditChildGuard],
              },
            ]
          },
          {
            path: 'order/:orderid',
            component: OrderDetailsComponent,
            canActivate: [PartnerProfileGuard],
          },
          {
            path: 'orders',
            component: OrdersComponent,
            canActivate: [PartnerProfileGuard],
          },
          {
            path: 'delete',
            component: PartnerDeleteComponent,
            canActivate: [PartnerProfileGuard],
          },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    TranslateModule,
    RouterModule.forChild(routes),
    GeneralModule,
    OrderModule,
  ],
  exports: [
    PartnerRegistrationComponent,
    PartnerRegistrationFormComponent,
    PartnerContactComponent,
    PartnerPasswordComponent,
    PartnerFormComponent,
    ChildrenListComponent,
    EditChildComponent,
    WaiverCheckboxComponent,
    CurrentPartnerContactComponent,
    PartnerConfirmationTextComponent,
  ],
  declarations: [
    PartnerPageComponent,
    PartnerRegistrationComponent,
    PartnerInfoComponent,
    ChildrenListComponent,
    WaiverDialogComponent,
    PartnerFormComponent,
    ChildrenManagementComponent,
    PartnerContactComponent,
    PartnerPasswordComponent,
    WaiverCheckboxComponent,
    PartnerRegistrationFormComponent,
    OrdersComponent,
    NewChildComponent,
    EditChildComponent,
    AddChildButtonComponent,
    PartnerEditComponent,
    OrderDetailsComponent,
    PartnerDeleteComponent,
    CurrentPartnerContactComponent,
    PartnerEditPopupComponent,
    PartnerConfirmationTextComponent,
  ],
  providers: [
    BookingStepService,
    PartnerStateService,
    PartnerProfileGuard,
    EditChildGuard,
    BookingSlotChangeStateService,
    { provide: PartnerService, useClass: partnerServiceClass }
  ],
  entryComponents: [
    WaiverDialogComponent,
    PartnerEditPopupComponent,
  ]
})
export class PartnerModule { }
